import { VesDamageKostenbelegModel } from './VesDamageKostenbeleg';
import { AppUtils } from '../../utils/index';
/**
 * Basic Model class for the DocumentsBills
 */
export class DocumentsBillsModel {
	private kostenart: Array<string>;
	private sonstigeBelege: { [id: string]: VesDamageKostenbelegModel };
	private kostenSummen: { [id: string]: string };
	private kostenAngaben: string;

	set Kostenart(value: Array<string>) {
		this.kostenart = value;
	}

	get Kostenart(): Array<string> {
		return this.kostenart;
	}

	set SonstigeBelege(value: { [id: string]: VesDamageKostenbelegModel }) {
		this.sonstigeBelege = value;
	}

	get SonstigeBelege(): { [id: string]: VesDamageKostenbelegModel } {
		return this.sonstigeBelege;
	}

	set KostenSummen(value: { [id: string]: string }) {
		this.kostenSummen = value;
	}

	get KostenSummen(): { [id: string]: string } {
		return this.kostenSummen;
	}

	public get KostenAngaben(): string {
		return this.kostenAngaben;
	}
	public set KostenAngaben(value: string) {
		this.kostenAngaben = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): DocumentsBillsModel {
		let belegeDict: { [id: string]: VesDamageKostenbelegModel };
		return AppUtils.Helper.createFromMap(dataObject, DocumentsBillsModel, (key: string, value: any) => {
			switch (key) {
				case 'kostenart':
					return (value instanceof Array) ? value : value.split(',');
				case 'kostenSummen':
					if (value) {
						const sumDict: { [id: string]: number } = {};
						Object.keys(value).forEach(key => {
							sumDict[key] = value[key];
						});
						return sumDict;
					}
					return [];
				case 'sonstigeBelege':
					belegeDict = {};
					if (value) {
						Object.keys(value).forEach(key => {
							belegeDict[key] = VesDamageKostenbelegModel.createFromObject(value[key]);
						});
					}
					return belegeDict;
				default:
					return value;
			}
		});
	}
}